import { render, staticRenderFns } from "./DisplayNameSection.vue?vue&type=template&id=cbd4e006&scoped=true&"
import script from "./DisplayNameSection.vue?vue&type=script&lang=js&"
export * from "./DisplayNameSection.vue?vue&type=script&lang=js&"
import style0 from "./DisplayNameSection.vue?vue&type=style&index=0&id=cbd4e006&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd4e006",
  null
  
)

export default component.exports